import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { getTotalCount } from 'utils/helpers';
import { FormattedMessage } from 'ui/i18n';

import './PackItemsList.scss';

export default class PackItemsList extends Component {
	static propTypes = {
		show: PropTypes.bool.isRequired,
		items: PropTypes.array.isRequired,
	};

	render() {
		const { show, items } = this.props;
		const showClassName = show ? 'PackItemsList-isShowing' : '';

		return (
			<div className={`PackItemsList ${showClassName} `}>
				<div className="PackItemsList-header">
					<FormattedMessage
						id="packItemList.packContains"
						values={{ itemCount: getTotalCount(items, 'quantity') }}
					/>
				</div>

				<div className="PackItemsList-content">
					<table className="PackItemsList-content-list">
						<thead>
							<tr>
								<td>
									<FormattedMessage id="ordersTable.descriptionColumn" />
								</td>
								<td>
									<FormattedMessage id="packItemList.itemNumberColumn" />
								</td>
								<td>
									<FormattedMessage id="itemsTable.qtyColumn" />
								</td>
							</tr>
						</thead>
						<tbody>
							{items.map((item, index) =>
								<tr key={index}>
									<td>
										{item.name}
									</td>
									<td>
										{item.is_configurable ? item.base_number : item.number}
									</td>
									<td>
										{item.quantity}
									</td>
								</tr>
							)}
						</tbody>
					</table>
				</div>
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./src/ui/components/PackItemsList/index.js